import React from "react";
import Responsive from "./responsive";

interface LobbyAdminProps {
  // Define any props you want to pass here
  // Example: title?: string;
}

const LobbyAdmin: React.FC<LobbyAdminProps> = () => {
  return (
    <div>
      <Responsive />
    </div>
  );
};

export default LobbyAdmin;
